<template>
  <div class="deskblock">
    <h3>最近7天系统开单数</h3>
    <div id="line2"></div>
  </div>
</template>
<script>
import echarts from "echarts";
import axios from "axios";
export default {
  data() {
    return {
      myData: [
        ["报警类型", "应付账款"],
        /* ["10-01", 2],
        ["10-02", 10],
        ["10-03", 12],
        ["10-04", 2],
        ["10-05", 10],
        ["10-06", 12],
        ["10-07", 12], */
      ],
    };
  },
  methods: {
    getData() {
      ///cloud-tms-server-omc/orders/indexPendingCount
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          //"/cloud-tms-server-omc/orders/indexDayReportCount",
          "/cloud-tmsx-server-web/orders/indexDayReportCount",
        data: {},
      }).then((res) => {
        var data = res.data.data;
        // item.num = data.ordersMoney;

        for (let i = 0; i < data.length; i++) {
          var arr = [];
          arr[0] = data[i].reportDate;
          arr[1] = data[i].kdCount;
          this.myData.push(arr);
        }
        this.drawBar();
      });
    },
    drawBar() {
      var that = this;
      this.chart = echarts.init(document.getElementById("line2"));
      this.option = {
        backgroundColor: "",
        /* title: {
          text: "车辆状况看板"
        }, */
        grid: {
          x: 20,
          y: 20,
          x2: 20,
          y2: 20, //距离下边的距离
        },

        tooltip: {
          //工具提示
          left: 20,
          formatter: function (t) {
            var val = t.value;
            return val[0] + "（" + val[1] + "个）";
          },
        },
        dataset: {
          source: this.myData,
        },
        xAxis: { type: "category" },
        yAxis: {},
        series: [
          //系列[
          {
            type: "line",
            color: ["#f83b3b"], // 设置折线上圆点大小
            //symbolSize: 10,

            label: {
              show: true,
              position: "top",
            },
            itemStyle: {
              normal: {
                // color: "#6cb041",
                lineStyle: {
                  width: 2, //设置线条粗细
                },
              },
            },
          },
          {
            type: "scatter",
            symbolSize: 16,
            color: ["#f83b3b"], // 设置折线上圆点大小
            //symbolSize: 10,
          },
          // { type: "bar", color: ["#3ebaf7"] },
          //{ type: "bar", color: ["#13ca7f"] },
          //{ type: "bar", color: ["#8d8d8d"] },
        ],
      };
      this.chart.setOption(this.option);

      this.chart.resize();
    },
  },
  //调用
  mounted() {
    this.getData();
  },
};
</script>
<style lang="">
#line2 {
  width: 100%;
  height: calc(100% - 20px);
}
</style>



// WEBPACK FOOTER //
// src/components/kanban/block8.vue